<template>
  <div :class="['agreementBox', { inApp: $root.$data.isApp }]">
    <template v-if="loadingTip">
      <van-loading
        size="24px"
        vertical
      >加载中...</van-loading>
    </template>
    <template v-else>
      <common-title
        titleName="我的协议"
        v-if="!$root.$data.isApp"
        :bcColor="'#FEFEFF'"
        :zIndex="1000"
      ></common-title>
      <div
        v-for="(item,index) in allSignedList"
        :key="index"
      >
        <div class="agreementList">
          <!-- 未签署 -->
          <div
            class="notSignedBox"
            v-if="item.status === 1"
          >
            <div class="notSigned">
              <h2 class="coursetTitle">{{item.agreementName}}</h2>
              <div class="productbox">
                <span>签署产品:</span>
                <ul>
                  <li
                    v-for="(product,index1) in item.productInfoVOS"
                    :key="index1"
                    :class="['ellipsis',{disableGray:product.status===3||product.status===4}]"
                  >{{product.productName}}</li>
                </ul>
              </div>
              <div
                class="rereadTimeLine"
                v-if="item.isReread"
              >
                <span>重读申请时间：</span>
                <b>{{item.reApplyStartTime.slice(0, 11)}}-{{item.reApplyEndTime.slice(0, 11)}}</b>
              </div>
              <div class="lookAgreement">
                <b>待签署</b>
                <div>
                  <span @click="agreementSigned(item.userProductId)">签署</span>
                </div>

              </div>

            </div>
          </div>
          <!-- 已签署 -->
          <div
            class="haveBeenSignedBox"
            v-if="item.status === 2"
          >
            <div class="haveBeenSigned">
              <h2 class="coursetTitle">{{item.agreementName}}</h2>
              <div class="productbox">
                <span>签署产品：</span>
                <ul>
                  <li
                    v-for="(product,index1) in item.productInfoVOS"
                    :key="index1"
                    :class="['ellipsis',{disableGray:product.status===3||product.status===4}]"
                  >{{product.productName}}</li>
                </ul>
              </div>
              <div class="agreementTime" v-if="item.deadlineTime && item.isShowValid===1">
                <span>有效期至:</span>
                <b>{{item.deadlineTime.slice(0, 11)}}</b>
              </div>
              <div
                class="rereadTimeLine"
                v-if="item.isReread"
              >
                <span>重读申请时间：</span>
                <b>{{item.reApplyStartTime.slice(0, 11)}}-{{item.reApplyEndTime.slice(0, 11)}}</b>
              </div>

              <div class="lookAgreement">
                <b v-if="item.isShowValid===1">生效中</b>
                <div>
                  <span
                    v-if="item.isReread"
                    @click="rereadBtn(item)"
                    class="rereadBtn"
                  >{{item.everRead===1&&(rereadTimeStatus(item)===2||rereadTimeStatus(item)===3)?`查看重读申请`:`重读申请`}}</span>
                  <span @click="lookAgreement(item.userProductId)">查看</span>
                </div>

              </div>
            </div>
          </div>
          <!-- 已过期 -->
          <div
            class="hasExpiredBox"
            v-if="item.status === 3"
          >
            <div class="hasExpired">
              <h2 class="coursetTitle">{{item.agreementName}}</h2>
              <div class="productbox">
                <span>签署产品：</span>
                <ul>
                  <li
                    class="ellipsis"
                    v-for="(product,index1) in item.productInfoVOS"
                    :key="index1"
                  >{{product.productName}}</li>
                </ul>
              </div>
              <div
                class="agreementTime"
                v-if="item.signingTime && item.deadlineTime && item.isShowValid===1"
              >
                <span>有效期至:</span>
                <b>{{item.deadlineTime.slice(0, 11)}}</b>
              </div>
              <div
                class="rereadTimeLine"
                v-if="item.isReread"
              >
                <span>重读申请时间：</span>
                <b>{{item.reApplyStartTime.slice(0, 11)}}-{{item.reApplyEndTime.slice(0, 11)}}</b>
              </div>
              <div class="lookAgreement">
                <b class="failure" v-if="item.isShowValid===1">
                  已失效
                </b>
                <div>
                  <span
                    v-if="item.isReread&&item.everRead===1&&rereadTimeStatus(item)!==1"
                    @click="rereadBtn(item)"
                    class="rereadBtn"
                  >查看重读申请</span>
                </div>

              </div>

            </div>
          </div>
          <!-- 已作废 -->
          <div
            class="hasExpiredBox"
            v-if="item.status === 4"
          >
            <div class="hasExpired">
              <h2 class="coursetTitle">{{item.agreementName}}</h2>
              <div class="productbox">
                <span>签署产品：</span>
                <ul>
                  <li
                    class="ellipsis"
                    v-for="(product,index1) in item.productInfoVOS"
                    :key="index1"
                  >{{product.productName}}</li>
                </ul>
              </div>
              <div
                class="agreementTime"
                v-if="item.signingTime&&item.deadlineTime && item.isShowValid===1"
              >
                <span>有效期至:</span>
                <b>{{item.deadlineTime.slice(0, 11)}}</b>
              </div>
              <div
                class="rereadTimeLine"
                v-if="item.isReread"
              >
                <span>重读申请时间：</span>
                <b>{{item.reApplyStartTime.slice(0, 11)}}-{{item.reApplyEndTime.slice(0, 11)}}</b>
              </div>
              <div class="failure" v-if="item.isShowValid===1">
                已作废
              </div>
            </div>
          </div>
        </div>
      </div>
      <template v-if="!allSignedList.length">
        <EmptyData :emptyName="'noAgreement'" />
      </template>
    </template>
  </div>
</template>

<script>
import CommonTitle from '@/components/header/CommonTitle.vue';
import { reqMyagreement } from '@/api/personal/myAgreement';
import EmptyData from '@/components/emptyData/emptyData.vue';
import { replaceHyphens } from '@/utils/tools';

export default {
  components: {
    CommonTitle,
    EmptyData,
  },
  data() {
    return {
      loadingTip: true,
      agreeList: {
        pageNum: 1,
        pageSize: 100,
      },
      allSignedList: {},
      currentTime: new Date().getTime(),

    };
  },

  computed: {

  },
  mounted() {
    this.getMyAgressment(this.agreeList);
  },

  methods: {
    async getMyAgressment(data) {
      const res = await reqMyagreement(data);
      if (res.code === 0) {
        this.currentTime = res.currentTime
          ? new Date(replaceHyphens(res.currentTime)).getTime()
          : new Date().getTime();

        //  签约状态 1 未签约 2 已签约 3 已过期
        this.allSignedList = res?.data?.data;
        this.loadingTip = false;
      } else {
        this.$toast('请求错误！');
      }
    },
    agreementSigned(userProductId) {
      this.$router.push({
        name: 'agreementDetail',
        query: {
          userProductId,
        },
      });
    },
    lookAgreement(userProductId) {
      this.$router.push({
        name: 'agreementDetail',
        query: {
          userProductId,
        },
      });
    },
    rereadTimeStatus(data) {
      // 1还未开始 2 进行中 3 已结束
      let status = 1;
      const reApplyEndTime = new Date(replaceHyphens(data.reApplyEndTime)).getTime();
      const reApplyStartTime = new Date(replaceHyphens(data.reApplyStartTime)).getTime();
      if (reApplyStartTime > this.currentTime) {
        status = 1;
      } else if (reApplyEndTime > this.currentTime && this.currentTime > reApplyStartTime) {
        status = 2;
      } else if (this.currentTime > reApplyEndTime) {
        status = 3;
      }
      return status;
    },
    // 重读申请
    rereadBtn(data) {
      if (this.rereadTimeStatus(data) === 1) {
        this.$toast('当前时间不在重读申请时间内，请核实后再申请~');
      } else if (this.rereadTimeStatus(data) === 2) {
        sessionStorage.setItem('REREAD', JSON.stringify(data));
        this.$router.push({
          name: 'readApplication',
        });
      } else if (this.rereadTimeStatus(data) === 3) {
        if (data.everRead === 1) {
          sessionStorage.setItem('REREAD', JSON.stringify(data));
          this.$router.push({
            name: 'readApplication',
          });
        } else {
          this.$toast('当前时间不在重读申请时间内，请核实后再申请~');
        }
      }
    },

  },
};

</script>

<style lang="scss" scoped>
.agreementBox {
  box-sizing: border-box;
  width: 100%;
  height: 100%;
  padding-top: 120px;
  padding-bottom: 20px;
  &.inApp {
    padding-top: 0;
    padding-bottom: 0;
  }
  .agreementList {
    box-sizing: border-box;
    width: 100%;
    padding: 0 36px;
    h2.coursetTitle {
      margin-bottom: 22px;
      color: #333;
      font-weight: 500;
      font-size: 29px;
      line-height: 40px;
    }
    div.productbox {
      display: flex;
      align-items: baseline;
      justify-content: space-between;
      margin-bottom: 10px;
      span {
        width: 200px;
        color: #333;
        font-weight: 500;
        font-size: 25px;
        line-height: 36px;
      }
      ul {
        width: 478px;
        li {
          width: 478px;
          height: 54px;
          margin-bottom: 14px;
          color: #666;
          font-weight: 400;
          font-size: 22px;
          line-height: 54px;
          text-indent: 24px;
          background: #fff;
          border: 2px solid #e8e8e8;
          border-radius: 4px;
        }
      }
    }
    div.rereadTimeLine {
      margin-bottom: 14px;
      font-size: 25px;
      line-height: 36px;
      span {
        padding-right: 7px;
        color: #333;
        font-weight: 500;
      }
      b {
        color: #787878;
        font-weight: 400;
      }
    }
    div.lookAgreement {
      display: flex;
      justify-content: space-between;
      padding-top: 14px;
      b {
        color: #ff6c02;
        font-weight: 400;
        font-size: 25px;
        line-height: 36px;
      }
      > div {
        display: flex;
        .rereadBtn {
          margin-right: 28px;
        }
      }
    }
    .notSignedBox {
      .notSigned {
        width: 100%;
        margin-bottom: 22px;
        padding: 43px 36px;
        background: #fff;
        border-radius: 14px;
        div.lookAgreement {
          span {
            height: 43px;
            padding: 0 24px;
            color: #fff;
            font-weight: 500;
            font-size: 22px;
            line-height: 43px;
            text-align: center;
            background: #ff6c02;
            border-radius: 29px;
          }
        }
      }
    }
    .agreementTime {
      margin-bottom: 14px;
      font-size: 25px;
      line-height: 36px;
      span {
        padding-right: 7px;
        color: #333;
        font-weight: 500;
      }
      b {
        color: #787878;
        font-weight: 400;
      }
    }
    .haveBeenSignedBox {
      .haveBeenSigned {
        width: 100%;
        margin-bottom: 22px;
        padding: 43px 36px;
        background: #fff;
        border-radius: 14px;
        div.lookAgreement {
          > div {
            span {
              height: 43px;
              padding: 0 24px;
              color: #ff6c02;
              font-weight: 500;
              font-size: 22px;
              line-height: 42px;
              text-align: center;
              border: 2px solid #ff6c02;
              border-radius: 29px;
            }
          }
        }
      }
    }
    .hasExpiredBox {
      .hasExpired {
        width: 100%;
        margin-bottom: 22px;
        padding: 43px 32px;
        background: #f5f5f5;
        border: 2px solid #eee;
        border-radius: 14px;
        .failure {
          color: #333;
          font-weight: 400;
          font-size: 25px;
          line-height: 36px;
        }
        div.lookAgreement {
          > div {
            span {
              height: 43px;
              margin-right: 0;
              padding: 0 24px;
              color: #ff6c02;
              font-weight: 500;
              font-size: 22px;
              line-height: 42px;
              text-align: center;
              border: 2px solid #ff6c02;
              border-radius: 29px;
            }
          }
        }
        .productbox {
          li {
            background: #f5f5f5;
          }
        }
      }
    }
    .disableGray {
      background: #f5f5f5 !important;
    }
  }
}
</style>
